var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parent-scanner"},[_c('CameraCodeScanner',{staticClass:"scanner-stream",on:{"load":_vm.onLoad,"scan":_vm.onDecode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }